import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { glossaryFetch } from "./actions/glossary";
import App from "./App";
import "./index.css";
import store from "./store";

store.dispatch(glossaryFetch());

const root = createRoot(document.getElementById("root")!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
